export enum DataHooks {
  Root = 'header',
  Title = 'header-title',
  Subtitle = 'header-subtitle',
}

export const HEADER_TITLE_ID = DataHooks.Title;
